import React, { useState } from 'react'
import { ThemeProvider } from '@mui/material/styles'
import theme from '../../theme'
import { StyledEngineProvider } from '@mui/material/styles'
import classes from './CreationName.module.css'
import { TextField } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import ShuffleIcon from '@mui/icons-material/Shuffle'

const CreationName = (props) => {
  // ----- Create a name randomly
  const generateName = () => {
    function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min)) + min
    }
    const syllables = [
      'ab',
      'le',
      'so',
      'ra',
      'tu',
      'mi',
      'ta',
      'me',
      'co',
      'te',
      'ac',
      'id',
      'ro',
      've',
      'al',
      'ep',
      'ab',
      'ir',
      'ol',
      'or',
      'do',
      'ce',
      'id',
    ]
    let nameContainer = []
    let nameString
    let num = getRandomInt(4, 6)
    for (let i = 0; i < num; i++) {
      nameContainer.push(
        syllables[Math.floor(Math.random() * syllables.length)],
      )
    }
    nameString = nameContainer.join('')
    return nameString.charAt(0).toUpperCase() + nameString.slice(1)
  }
  // -----

  const [shuffleName, setShuffleName] = useState('')
  const shuffleInvaderName = () => {
    setShuffleName(generateName())
  }
  const shuffleNameChange = (event) => {
    setShuffleName(event.target.value)
  }

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <div className={classes.container}>
          <div className={classes.innerContainer}>
            <TextField
              inputRef={props.forwardedRef}
              className={classes.inputText}
              label="Invader's Name"
              value={shuffleName}
              onChange={shuffleNameChange}
              variant="outlined"
            />
            <IconButton
              className={classes.iconButton}
              size="large"
              color="primary"
              variant="outlined"
              onClick={shuffleInvaderName}
            >
              <ShuffleIcon fontSize="inherit" />
            </IconButton>
          </div>
        </div>
      </ThemeProvider>
    </StyledEngineProvider>
  )
}

export default CreationName
